import React, { PropsWithChildren } from "react";
import { useRouter } from "next/router";
import { routesDefinitions } from "lib/actions/routeDefinitions";
import EmptyLayout from "./EmptyLayout";
import SpatialViewerLayout from "./SpatialViewerLayout";
import SpatialViewerOnlyLayout from "./SpatialViewerOnlyLayout";
import HeaderAndNavLayout from "./HeaderAndNavLayout";
import HeaderWithoutNavLayout from "./HeaderWithoutNavLayout";
import AuthLayout from "./AuthLayout";
import HalfAndHalfDonutLayout from "./HalfAndHalfDonutLayout";

/** Route paths to layouts. Resulting layout is the first regular
 *  expression that matches the url pathname (initial '/' followed
 *  by the path of the URL not including the query string or fragment.)
 */
const routeLayouts = [
  { path: /^\/$/, layout: "spatialViewer" }, //root only
  { path: routesDefinitions.projects.regex, layout: "spatialViewer" },
  { path: routesDefinitions.projectTransferBegin.regex, layout: "halfDonut" },
  { path: routesDefinitions.projectsCreate.regex, layout: "basic" },
  { path: routesDefinitions.project.regex, layout: "spatialViewerOnly" },
  { path: routesDefinitions.projectSettings.regex, layout: "headerAndNav" },

  {
    path: routesDefinitions.projectTransferAccept.regex,
    layout: "basic",
  },
  { path: routesDefinitions.layers.regex, layout: "spatialViewer" },
  { path: routesDefinitions.views.regex, layout: "spatialViewer" },
  { path: routesDefinitions.assetPages.regex, layout: "spatialViewer" },
  { path: routesDefinitions.modelElement.regex, layout: "spatialViewer" },
  { path: routesDefinitions.issues.regex, layout: "spatialViewer" },
  { path: routesDefinitions.search.regex, layout: "spatialViewer" },
  { path: routesDefinitions.members.regex, layout: "headerAndNav" },
  { path: routesDefinitions.workspacesCreate.regex, layout: "basic" },
  {
    path: routesDefinitions.workspacesSettings.regex,
    layout: "headerWithoutNav",
  },
  { path: routesDefinitions.workspacePaywall.regex, layout: "halfDonut" },
  { path: routesDefinitions.auth.regex, layout: "auth" },
  { path: routesDefinitions.invitesForm.regex, layout: "halfDonut" },
  { path: routesDefinitions.invites.regex, layout: "auth" },
  { path: routesDefinitions.registerForm.regex, layout: "halfDonut" },
  { path: routesDefinitions.register.regex, layout: "auth" },
  { path: routesDefinitions.accountSettings.regex, layout: "headerWithoutNav" },
  { path: /^\/.*/, layout: "basic" }, //otherwise
] as const;

const LayoutRouter = (p: PropsWithChildren<{}>) => {
  const router = useRouter();
  const layout = routeLayouts.find((r) => r.path.test(router.pathname))?.layout;

  const Layout = (Component: React.FC<PropsWithChildren<{}>>) => {
    return <Component>{p.children}</Component>;
  };

  switch (layout) {
    case "spatialViewer":
      return Layout(SpatialViewerLayout);
    case "spatialViewerOnly":
      return Layout(SpatialViewerOnlyLayout);
    case "headerAndNav":
      return Layout(HeaderAndNavLayout);
    case "headerWithoutNav":
      return Layout(HeaderWithoutNavLayout);
    case "auth":
      return Layout(AuthLayout);
    case "halfDonut":
      return Layout(HalfAndHalfDonutLayout);
    case "basic":
    default:
      break;
  }
  return Layout(EmptyLayout);
};

export default LayoutRouter;
